<div class="row feedback-container">

    <mat-icon *ngIf="showWarning"
              class="feedback-warning"
              [matTooltip]="warningMessage | translate "
              matTooltipClass="mat-tooltip-cp no-margin"
              matTooltipPosition="above"
              [matTooltipShowDelay]="delay">warning</mat-icon>

    <mat-icon *ngIf="showError"
              class="feedback-error"
              [matTooltip]="errorMessage | translate"
              matTooltipClass="mat-tooltip-cp no-margin"
              matTooltipPosition="above"
              [matTooltipShowDelay]="delay">error</mat-icon>

    <div *ngIf="showSuccess"
         class="feedback-success"
         [matTooltip]="successMessage | translate"
         matTooltipClass="mat-tooltip-cp no-margin"
         matTooltipPosition="above"
         [matTooltipShowDelay]="delay"></div>
</div>
